import { Space } from 'antd';
import styled from 'styled-components';

export default styled(Space)`
	// Add your styles here
`;
